import { type ReactNode } from "react";

/** Flexbox stretches cards to the tallest card in their own wrapped row. */
export function EqualHeightProductList({ className, children }: { className: string; children: ReactNode }) {
  return <div className={className} style={{ alignItems: "stretch", alignContent: "flex-start" }}>{children}</div>;
}
